import { Injectable } from '@angular/core';
import { IChecklistV2, ICheckpointGroup } from './checklist-v2';
import { cloneDeep } from '../utils';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FiChecklistEditorStoreService {
    private _initialChecklistData: IChecklistV2;
    setInitialChecklistData(checklistData: IChecklistV2) {
        this._initialChecklistData = cloneDeep(checklistData);
    }
    getInitialChecklistData(): IChecklistV2 {
        return this._initialChecklistData;
    }

    private _currentChecklistData$ = new BehaviorSubject<IChecklistV2>(undefined);
    getCurrentChecklistData$(): BehaviorSubject<IChecklistV2> {
        return this._currentChecklistData$;
    }
    setCurrentChecklistData$(value: IChecklistV2) {
        this._currentChecklistData$.next(value);
        this.setCurrentCheckpointGroups(value?.CheckpointGroups);
    }

    private _currentCheckpointGroups: ICheckpointGroup[];
    setCurrentCheckpointGroups(value: ICheckpointGroup[] = []) {
        this._currentCheckpointGroups = [...value];
    }
    getCurrentCheckpointGroups(): ICheckpointGroup[] {
        return this._currentCheckpointGroups;
    }

    updateCheckpointGroupsOnChecklist(newCheckpointGroups: ICheckpointGroup[]) {
        const currentChecklist: IChecklistV2 = this._currentChecklistData$.value;
        currentChecklist.CheckpointGroups = [...newCheckpointGroups];
        this.setCurrentChecklistData$(currentChecklist);
    }

    resetChecklistEditorStoreData() {
        this.setInitialChecklistData(undefined);
        this.setCurrentChecklistData$(undefined);
        this.setCurrentCheckpointGroups([]);
    }
}
